// extracted by mini-css-extract-plugin
module.exports = {"title":"detail_title_1vgPe"};